// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("bg.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  min-height: 100%;
  min-width: 1024px;
}

.spinner {
  text-align: center;
}

.submitButton {
  text-align: right;
}

.optionalUpload {
  margin: 0 auto;
  width: 100%;
}

.optionalUploadItem {
  display: inline-block;
  width: 100px;
}
.optionalUploadItemBig {
  display: inline-block;
  width: 558px;
}

.footer {
  font-size: 10px;
}

.notice {
  font-size: 11px;
}
.statusActive {
  display: inline-block;
  vertical-align: middle;

  color: #3b84fe;
}

.almostDone {
  font-size: 23px;
  font-weight: bold;
  text-align: left;
  color: grey;
}

.reviewButton {
  width: 200px;
  text-align: left;
}

.instruction {
  font-size: 12px;
  text-align: left;
  color: grey;
}

.statusActiveValid {
  display: inline-block;
  vertical-align: middle;

  color: green;
}

.nextButton {
  padding-left: 10px;
  display: inline-block;
}

.backButton {
  display: inline-block;
}

.sectionHeader {
  font-size: 43px;
  font-weight: bold;
  text-align: right;
  color: grey;
}

.statusInactive {
  display: inline-block;
  vertical-align: middle;

  color: grey;
}

.header {
  width: 60vw;
}

.statusCard {
  font-size: 52px;
  text-align: center;
  font-weight: 700;
  width: 100%;
}

.bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  width: 100vw;
  height: 100vw;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.navButtons {
  text-align: right;

  width: 100%;
}
.parent {
  margin: 1rem;
  text-align: center;
  background-color: white;
}

.navSection {
  display: inline-block;
  vertical-align: top;
  width: 25%;
  height: 100%;
  text-align: left;
}

.formContent {
  display: inline-block;
  vertical-align: middle;
  width: 75%;
  text-align: left;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.optional {
  display: inline-block;

  color: #0f7002;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.head-text {
  position: relative;
}
.text-on-image {
  position: absolute;
  right: 15%;
  left: 15%;
  top: 15%;
  color: white;
}

.optionalRow {
  display: inline-block;
}

.feedbackButtons {
  display: inline-block;
  width: 80%;
}

.feedbackButton {
  display: inline-block;
  margin-right: 20px;
}

.feedbackButtonRight {
  display: inline-block;
}

.questionsBackground {
  background-color: #6599ca;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;;EAEtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;;EAEtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;;EAEtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yDAAgC;;EAEhC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;;EAEjB,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".App {\n  text-align: center;\n  min-height: 100%;\n  min-width: 1024px;\n}\n\n.spinner {\n  text-align: center;\n}\n\n.submitButton {\n  text-align: right;\n}\n\n.optionalUpload {\n  margin: 0 auto;\n  width: 100%;\n}\n\n.optionalUploadItem {\n  display: inline-block;\n  width: 100px;\n}\n.optionalUploadItemBig {\n  display: inline-block;\n  width: 558px;\n}\n\n.footer {\n  font-size: 10px;\n}\n\n.notice {\n  font-size: 11px;\n}\n.statusActive {\n  display: inline-block;\n  vertical-align: middle;\n\n  color: #3b84fe;\n}\n\n.almostDone {\n  font-size: 23px;\n  font-weight: bold;\n  text-align: left;\n  color: grey;\n}\n\n.reviewButton {\n  width: 200px;\n  text-align: left;\n}\n\n.instruction {\n  font-size: 12px;\n  text-align: left;\n  color: grey;\n}\n\n.statusActiveValid {\n  display: inline-block;\n  vertical-align: middle;\n\n  color: green;\n}\n\n.nextButton {\n  padding-left: 10px;\n  display: inline-block;\n}\n\n.backButton {\n  display: inline-block;\n}\n\n.sectionHeader {\n  font-size: 43px;\n  font-weight: bold;\n  text-align: right;\n  color: grey;\n}\n\n.statusInactive {\n  display: inline-block;\n  vertical-align: middle;\n\n  color: grey;\n}\n\n.header {\n  width: 60vw;\n}\n\n.statusCard {\n  font-size: 52px;\n  text-align: center;\n  font-weight: 700;\n  width: 100%;\n}\n\n.bg {\n  background-image: url(\"bg.jpeg\");\n\n  width: 100vw;\n  height: 100vw;\n  background-size: cover;\n  -webkit-background-size: cover;\n  -moz-background-size: cover;\n  -o-background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  overflow: hidden;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.navButtons {\n  text-align: right;\n\n  width: 100%;\n}\n.parent {\n  margin: 1rem;\n  text-align: center;\n  background-color: white;\n}\n\n.navSection {\n  display: inline-block;\n  vertical-align: top;\n  width: 25%;\n  height: 100%;\n  text-align: left;\n}\n\n.formContent {\n  display: inline-block;\n  vertical-align: middle;\n  width: 75%;\n  text-align: left;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.optional {\n  display: inline-block;\n\n  color: #0f7002;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.head-text {\n  position: relative;\n}\n.text-on-image {\n  position: absolute;\n  right: 15%;\n  left: 15%;\n  top: 15%;\n  color: white;\n}\n\n.optionalRow {\n  display: inline-block;\n}\n\n.feedbackButtons {\n  display: inline-block;\n  width: 80%;\n}\n\n.feedbackButton {\n  display: inline-block;\n  margin-right: 20px;\n}\n\n.feedbackButtonRight {\n  display: inline-block;\n}\n\n.questionsBackground {\n  background-color: #6599ca;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
